// src/pages/SearchPage.js
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import BottomNav from '../components/BottomNav';

export default function SearchPage() {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [recent] = useState(['Adidas Samba', 'Nike store', 'Skincare deals', 'iPhone']);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const search = async (q) => {
    if (!q.trim()) return;
    setLoading(true);
    setResults(null);
    try {
      const data = await api.search(q.trim());
      setResults({ stores: data.stores, products: data.products, summary: `Results for "${q}"` });
    } catch {
      setResults({ stores: [], products: [], summary: '' });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    search(query);
  };

  return (
    <div className="search-root">
      <div className="search-header">
        <button className="back-icon-btn" onClick={() => navigate('/')}>←</button>
        <form className="search-form" onSubmit={handleSubmit}>
          <span className="search-icon-inner">⌕</span>
          <input
            ref={inputRef}
            className="search-input"
            value={query}
            onChange={e => setQuery(e.target.value)}
            placeholder="Samba, Nike store, iPhone, skincare…"
          />
          {query && <button type="button" className="search-clear" onClick={() => { setQuery(''); setResults(null); }}>×</button>}
        </form>
      </div>

      <div className="search-body">
        {!query && !results && (
          <div className="search-suggestions">
            <p className="suggestions-label">Recent searches</p>
            {recent.map(r => (
              <button key={r} className="suggestion-row" onClick={() => { setQuery(r); search(r); }}>
                <span className="suggestion-icon">↗</span>
                <span>{r}</span>
              </button>
            ))}
            <p className="suggestions-label" style={{ marginTop: 24 }}>Try searching for</p>
            {['Deals near me', 'Adidas Samba', 'Skincare under ₹5000', 'Sports shoes'].map(s => (
              <button key={s} className="suggestion-row suggested" onClick={() => { setQuery(s); search(s); }}>
                <span className="suggestion-icon">✦</span>
                <span>{s}</span>
              </button>
            ))}
          </div>
        )}

        {loading && (
          <div className="search-loading">
            <div className="ai-thinking">
              <span className="ai-dot" /><span className="ai-dot" /><span className="ai-dot" />
            </div>
            <p>Searching…</p>
          </div>
        )}

        {results && !loading && (
          <div className="search-results">
            {results.stores?.length > 0 && (
              <div className="results-section">
                <p className="results-label">Stores</p>
                {results.stores.map(store => (
                  <div key={store.id} className="result-store-row" onClick={() => navigate(`/store/${store.id}`)}>
                    <div className="result-store-img" style={{ backgroundImage: store.imageUrl ? `url(${store.imageUrl})` : undefined }}>
                      {!store.imageUrl && '🏪'}
                    </div>
                    <div className="result-store-info">
                      <p className="result-store-name">{store.name}</p>
                      <p className="result-store-meta">{store.category} · Floor {store.floorNumber ?? '–'}</p>
                    </div>
                    {store._count?.coupons > 0 && <span className="result-deal-badge">{store._count.coupons} deal{store._count.coupons > 1 ? 's' : ''}</span>}
                    <span className="result-arrow">›</span>
                  </div>
                ))}
              </div>
            )}

            {results.products?.length > 0 && (
              <div className="results-section">
                <p className="results-label">Products</p>
                <div className="results-product-grid">
                  {results.products.map(product => (
                    <div key={product.id} className="result-product-card" onClick={() => navigate(`/product/${product.id}`)}>
                      <div className="result-product-img" style={{ backgroundImage: product.imageUrl ? `url(${product.imageUrl})` : undefined }}>
                        {!product.imageUrl && '📦'}
                      </div>
                      <p className="result-product-name">{product.name}</p>
                      <p className="result-product-price">₹{product.price.toLocaleString()}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {results.stores?.length === 0 && results.products?.length === 0 && (
              <div className="no-results">
                <p>No results found for "<strong>{query}</strong>"</p>
                <p>Try searching for a brand, product or category.</p>
              </div>
            )}
          </div>
        )}
      </div>

      <BottomNav active="search" />
    </div>
  );
}
